import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { deadline: String, expiredText: { type: String, default: "Encerrado" } }

  connect() {
    this.update()
    this.timer = setInterval(() => this.update(), 1000)
  }

  disconnect() {
    if (this.timer) clearInterval(this.timer)
  }

  update() {
    const deadline = new Date(this.deadlineValue)
    const now = new Date()
    const diff = deadline - now

    if (diff <= 0) {
      this.element.textContent = this.expiredTextValue
      this.element.classList.add("countdown--expired")
      clearInterval(this.timer)
      this.removeCardFromIndex()
      return
    }

    const days = Math.floor(diff / 86400000)
    const hours = Math.floor((diff % 86400000) / 3600000)
    const minutes = Math.floor((diff % 3600000) / 60000)
    const seconds = Math.floor((diff % 60000) / 1000)

    if (days > 0) {
      this.element.textContent = `${days}d ${hours}h ${minutes}m`
    } else if (hours > 0) {
      this.element.textContent = `${hours}h ${minutes}m ${seconds}s`
    } else if (minutes > 0) {
      this.element.textContent = `${minutes}m ${seconds}s`
    } else {
      this.element.textContent = `${seconds}s`
    }

    // Urgencia visual nos ultimos 60 segundos
    if (diff < 60000) {
      this.element.classList.add("countdown--urgent")
    } else if (diff < 300000) {
      this.element.classList.add("countdown--warning")
    }
  }

  removeCardFromIndex() {
    const card = this.element.closest("[id^='card_market_']")
    if (!card) return

    // So remove se estiver no grid do index, nao na pagina show
    const grid = card.closest("#markets_grid, .markets-grid")
    if (!grid) return

    card.style.transition = "opacity 0.5s, transform 0.5s"
    card.style.opacity = "0"
    card.style.transform = "scale(0.95)"
    setTimeout(() => card.remove(), 500)
  }
}
